<template>
  <div class="container">
    <loading :active="loading" :is-full-page="true" loader="bars"></loading>
    <div class="row">
      <div class="col-md-8 mt-5 mx-auto">
        <router-link to="/admins" class="btn btn-sm btn-primary mb-3"
          >Back</router-link
        >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Add Admin</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="submit" ref="addUser" autocomplete="off">
              <div class="form-group row">
                <div class="col-md-6">
                  <label>First Name <span class="text-danger">*</span></label>
                  <span class="text-danger d-block" v-if="errors.f_name">
                    First Name is required
                  </span>
                  <input
                    type="text"
                    class="form-control mb-3"
                    required
                    v-model="admin.f_name"
                    placeholder="First Name"
                  />
                </div>
                <div class="col-md-6">
                  <label>Last Name</label>
                  <input
                    type="text"
                    class="form-control mb-3"
                    v-model="admin.l_name"
                    placeholder="Last Name"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Phone</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  v-model="admin.phone"
                  maxlength="11"
                  placeholder="03011234567"
                  @keypress="numberOnly($event)"
                />
              </div>
              <div class="form-group">
                <label>Email <span class="text-danger">*</span></label>
                <span class="text-danger d-block" v-if="errors.email">
                  Email is required
                </span>
                <input
                  type="email"
                  placeholder="info@email.com"
                  class="form-control mb-3"
                  required
                  v-model="admin.email"
                  pattern="[^\s@]+@[^\s@]+\.[^\spatt@]+"
                  autocomplete="new-email"
                />
              </div>
              <div class="form-group">
                <label>Password <span class="text-danger">*</span></label>
                <span class="text-danger d-block" v-if="errors.password">
                  Password is required
                </span>
                <input
                  type="password"
                  class="form-control mb-3"
                  required
                  v-model="admin.password"
                  placeholder="***************"
                  autocomplete="new-password"
                />
              </div>
              <div class="form-group">
                <label>Role <span class="text-danger">*</span></label>
                <select
                  class="select-form-control"
                  v-model="admin.role"
                  required
                >
                  <option value="">Select...</option>
                  <option v-for="role in roles" :value="role.name">
                    {{ role.name }}
                  </option>
                </select>
              </div>
              <div class="row mt-3">
                <div class="col-md-9">
                  <button type="submit" class="btn btn-lg btn-primary w-100">
                    Save
                  </button>
                </div>
                <div class="col-md-3">
                  <button
                    type="reset"
                    class="btn btn-lg btn-outline-danger w-100"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toRaw } from "vue";
import { isNumber } from "@/helpers/helpers";

export default {
  data() {
    return {
      admin: {
        f_name: null,
        l_name: null,
        phone: null,
        email: null,
        password: null,
        role: "",
        createdBy: localStorage.getItem("uid"),
      },
      roles: [],
      errors: [],
      loading: false,
    };
  },
  mounted() {
    this.fetchRoles();
  },
  methods: {
    numberOnly(evt) {
      isNumber(evt);
    },
    submit() {
      this.loading = true;
      this.errors = [];
      const data = toRaw(this.admin);
      this.$store
        .dispatch("admins/store", { data })
        .then((response) => {
          this.loading = false;
          this.$toast.show("Successfuly added.", {
            theme: "outline",
            position: "top",
            type: "success",
            duration: 5000,
          });
          Object.keys(this.admin).forEach((key) => (this.admin[key] = null));
          this.admin.role = "";
          this.admin.createdBy = localStorage.getItem("uid");
          this.errors = [];
        })
        .catch((e) => {
          this.loading = false;
          this.errors = e.error;
        });
    },
    fetchRoles() {
      this.loading = true;
      const search = "";
      this.$store
        .dispatch("roles/getAll", { search })
        .then((response) => {
          this.roles = response.data.data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e.error);
        });
    },
  },
};
</script>
